import { render, staticRenderFns } from "./ChatbotMessage.vue?vue&type=template&id=9fbaea80"
import script from "./ChatbotMessage.vue?vue&type=script&lang=js"
export * from "./ChatbotMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatbotMessage.vue?vue&type=style&index=0&id=9fbaea80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports